import { render, staticRenderFns } from "./page-layout.vue?vue&type=template&id=6fd02a79&scoped=true"
import script from "./page-layout.vue?vue&type=script&lang=js"
export * from "./page-layout.vue?vue&type=script&lang=js"
import style0 from "./page-layout.vue?vue&type=style&index=0&id=6fd02a79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd02a79",
  null
  
)

export default component.exports